import styled from 'styled-components';

export const ListWrapper = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: ${({ theme }) => theme.space[5]}px;

  li {
    margin-bottom: ${({ theme }) => theme.space[3]}px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
